(function () {
    angular.module("dashboard")
        .component("orderUpOrderCard", {
                templateUrl: "components/store/order-up/order-up-order-card.ca673e6e.html",
                bindings: {
                    isSelected: "<",
                    order: "<"
                },
                controller: [ "moment", OrderCardComponent ]
            }
        );

    function OrderCardComponent(moment) {
        this.moment = moment;
        this.timeSinceOrderPlaced = "now";
    }

    OrderCardComponent.prototype = {
        $doCheck: function () {
            if (!this.order) {
                return;
            }
            this.orderPaidStatus = this.getPaidStatus();
            this.customerName = this.getCustomerName();
        },
        $onInit: function () {
            this.updateTimeSinceOrderPlaced();
            this.timeSincePlacedInterval = window.setInterval(
                () => this.updateTimeSinceOrderPlaced(),
                10000);
        },
        $onDestroy: function () {
            window.clearInterval(this.timeSincePlacedInterval);
        },
        timeSinceOrderPlacedInMinutes: function () {
            if (!this.order) {
                return 0;
            }
            const orderDate = this.moment.utc(this.order.Date);
            return this.moment.utc().diff(orderDate, "minutes");
        },
        updateTimeSinceOrderPlaced: function () {
            if (!this.order) {
                return;
            }
            this.timeSinceOrderPlaced = window.Dashboard.helpers.time.timeSince(this.order.Date);
        },
        getPaidStatus: function () {
            return this.order.NetAmountOutstanding === 0
                ? "Paid"
                : "";
        },
        getCustomerName: function () {
            const
                customerName = this.order.CustomerFirstName,
                initial = this.order.CustomerLastName && this.order.CustomerLastName ? this.order.CustomerLastName[0] : "";
            return `${customerName} ${initial}.`;
        }
    }

})();
